import type { HelpFile } from '../../types/help'
import { SapAbapConfigCardTestIds } from '../../../testids/SapAbapConfigCardTestIds'

export const sapAbapConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-abap-connector',
  texts: {
    [SapAbapConfigCardTestIds.Section]: null,
    [SapAbapConfigCardTestIds.btnCreateSapAbapConfig]: null,
  },
}
